import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LoginDetails, subscriptionOption, SubscriptionDetails, SubscriptionFormObj, UserSubscriptionLoginResponse, UserSubscriptionRegisterResponse, userRegisterPayload, SubscriptionUser, UpdatePayload, SaveSubscriptionInfo } from '../../models/user.subscription.interface'
import { API_ROUTES } from '../../util/route.constants';
import { environment } from '../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {

  email: string = ""
  private subscription!: SubscriptionFormObj;
  planUID: string;
  constructor(private readonly http: HttpClient) { }
  verifyUser(email: string): Observable<{ response: boolean }> {
    this.email = email;
    return this.http.get<{ response: boolean }>(`${environment.cva_url}/${API_ROUTES.SUBSCRIPTION_VERIFY}/${email}`)
  }
  login(userdetails: LoginDetails): Observable<{ response: UserSubscriptionLoginResponse }> {
    return this.http.post<{ response: UserSubscriptionLoginResponse }>(`${environment.cva_url}/${API_ROUTES.SUBSCRIPTION_LOGIN}`, userdetails)
  }
  register(userdetails: userRegisterPayload): Observable<{ response: UserSubscriptionRegisterResponse }> {
    return this.http.post<{ response: UserSubscriptionRegisterResponse }>(`${environment.cva_url}/${API_ROUTES.SUBSCRIPTION_REGISTER}`, userdetails)
  }
  getSubscriptionList(): Observable<{ response: subscriptionOption[] }> {
    return this.http.get<{ response: subscriptionOption[] }>(`${environment.cva_url}/${API_ROUTES.SUBSCRIPTION_PRICING}`)
  }

  getSubscriptionDetails(): Observable<{ success: true, data: SubscriptionDetails }> {
    return this.http.get<{ success: true, data: SubscriptionDetails }>(`${environment.user_management_api_url}/${API_ROUTES.SUBSCRIPTION_DETAILS}`)
  }
  getSubscriptionUserDetails(email: string): Observable<{ response: SubscriptionUser }> {
    return this.http.get<{ response: SubscriptionUser }>(`${environment.cva_url}/${API_ROUTES.GET_SUBSCRIPTION_USER}/${email}`)
  }
  getCustomerEmail() {
    return this.email;
  }
  setSubscriptionObj(subscriptionObj: SubscriptionFormObj) {
    this.subscription = subscriptionObj
  }
  getSubscriptionObj(): SubscriptionFormObj | undefined {
    return this.subscription
  }

  setPlanUID(planId: string) {
    this.planUID = planId;
  }

  getPlanUUID() {
    return this.planUID
  }

  updateRole(updatePayload: UpdatePayload): Observable<{ success: boolean, message: string }> {
    return this.http.post<{ success: boolean, message: string }>(`${environment.user_management_api_url}${API_ROUTES.UPDATE_ROLE}`, updatePayload)
  }

  saveUserSignupSubscription(payload: SaveSubscriptionInfo) {
    return this.http.post<{ success: boolean, message: string }>(`${environment.cva_url}${API_ROUTES.SAVE_USER_AT_SIGNUP}`, payload)
  }
}
